export enum RoutePath {
  // App paths
  APP_LINK_REDIRECT = '/redirect',
  SUPPORT = '/support',
  AI_CHAT = '/ai-chat',
  AI_CHAT_PERFORMANCE = '/ai-chat-performance',
  AUTHORING_POC = '/authoring-poc',
  AI_CHAT_ADMIN = '/ai-chat-admin',
  YOUR_CHATS = '/your-chats',
  YOUR_BOOKS = '/your-books',
  QUIZ_QUESTIONS = '/quiz-questions',
  FLASHCARDS = '/flashcards',
  HOW_IT_WORKS = '/how-it-works',

  // Shared paths
  TIMEOUT = '/timedOut',
  LOGIN = '/login',
  LOGOUT = '/logout',
  PAGE_NOT_FOUND = '/pageNotFound',
  HELP = '/help',
  NOT_AUTHORIZED = '/notAuthorized',
  MAINTENANCE = '/maintenance',
  UNEXPECTED_ERROR = '/unexpectedError',
}

export const ServicePath = {
  loginPath: '/login-service/login',
  tokenServicePath: '/token-service',
  tokenServiceV2Path: '/v2/token-service/tokens',
  userServicePath: '/apiv1/eolsUser/list',
};

export const AppConstants = {
  APP_ID: 'NHE_AI',
  FEATURE_FLAG_APP: 'NHE_AI_APP',
  IDLE_TIMEOUT: 1000 * 60 * 60 * 24,
  PENDO_API_KEY: '4c751ddb-f36d-4300-b39a-4a3c3bb437a1', // '94bb3f52-df30-4f69-4ec8-dceb6bffffbe'
};

export const UNKNOWN = 'UNKNOWN';
export const PERSIST_KEY = 'globalAppState';

export const REFRESH_CHECK_INTERVAL_MS = 60 * 1000;

// Deliberately a fixed lead time rather than anything derived from getTimeToRefresh(): that
// helper returns max(timeToExpiration * 0.9, 60_000), so comparing it against the same
// timeToExpiration collapses to "within the last 60 seconds" and gives us a single chance to
// recover. Five minutes leaves ~5 ticks of the interval below to land a successful refresh.
export const REFRESH_LEAD_TIME_MS = 5 * 60 * 1000;
